export default __webpack_public_path__ + "static/media/ProximaNova-Regular.a704ce8e.woff";